export function disableLastPassInputRef(input) {
  if (input && input.inputRef) {
    // HACK (jscheel): Deal with createRef refs and callback refs
    const el = input.inputRef.current || input.inputRef
    if (el) {
      el.setAttribute('data-lpignore', 'true')
    }
  }
}
